import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';
import { StateService } from '../../../core/services/state.service';
import { TranslateService } from '../../../core/services/translate.service';
import { UtilityService } from '../../../core/services/utility.service';

@Component({
  selector: 'tt-stock-location-ctrl',
  templateUrl: './stock-location-ctrl.component.html',
  styleUrls: ['./stock-location-ctrl.component.css']
})
export class StockLocationCtrlComponent implements OnInit {
    stockKeyno;

    public translations: { [key: string]: string } = {
        stocklocationctrl_sum: ''
    };

    public edit?: Edit;

    public selectListStockCounts: Item[] = [];

    public inputListControllers: ControllerItem[] = [];

    public saving = false;

    constructor(private stateService: StateService, private utility: UtilityService, private translateService: TranslateService, private modal: ModalService, private datatask: DataTaskService) {
        this.stockKeyno = this.stateService.getStateParams()['stock_keyno'];
    }

    private async translate() {
    	const response = await this.translateService.translateBatch(Object.keys(this.translations));

    	Object.keys(this.translations).forEach((key) => {
    		if (response[key]) {
    			this.translations[key] = response[key];
    		}
    	});
    }

    private async loadEdit() {
        if (!!this.stockKeyno) {
            this.edit = (await this.datatask.Post(1077, { stock_keyno: this.stockKeyno }))[0];
        }
    }

    private async loadStockCounts() {
        if (!this.edit) return;

        return this.selectListStockCounts = await this.datatask.Post(951, {
            stockplace_id: this.edit.stockplace_id,
            bg_stockcount_status: 'ALL'
        });
    }

    private async loadControllers() {
        if (!this.edit) return;

        return this.inputListControllers = await this.datatask.Post(1078, this.edit);
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const mergeObj = {
                	...this.edit,
                	records: this.inputListControllers
                }

                const response = (await this.datatask.Post(1079, mergeObj))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    private async recalcAll() {
        this.recalcSumQuantity('quantity_stock');
        this.recalcSumQuantity('quantity_stockcount');
        this.recalcSumQuantity('quantity_controlled');
    }

    private async recalcSumQuantity(id: string) {
        if (!this.edit) return;

        if (!!this.inputListControllers) {
            let recalcSum = 0;

            this.inputListControllers.forEach((data: any) => {
                switch (id) {
                    case 'quantity_stock':
                    case 'quantity_stockcount':
                    case 'quantity_controlled':
                        if (data[id] === undefined || data[id] === null || data[id] === '') {
                            recalcSum += 0;
                        } else {
                            recalcSum += this.utility.parseNumber(data[id]);
                        }
                        break;
                    default:
                        break;
                }
            });

            switch (id) {
                case 'quantity_stock':
                    this.edit.sum_quantity_stock = recalcSum.toString();
                    break;
                case 'quantity_stockcount':
                    this.edit.sum_quantity_stockcount = recalcSum.toString();
                    break;
                case 'quantity_controlled':
                    this.edit.sum_quantity_controlled = recalcSum.toString();
                    break;
                default:
                    break;
            }
        }
    }

    public async onChanged(_: string, id: keyof Edit) {
        if (!this.edit) return;

        switch (id) {
            case 'stockcount_keyno':
                await this.loadControllers();
                this.recalcAll();
                break;
            default:
                break;
        }
    }

    public async onInputListChanged(_: string, id: keyof ControllerItem) {
        if (!this.inputListControllers) return;

        switch (id) {
            case 'quantity_controlled':
                this.recalcSumQuantity('quantity_controlled');
                break;
            default:
                break;
        }
    }

    private async init() {
        this.translate();
        await this.loadEdit();
        this.loadStockCounts();

        Promise.all([
            this.loadControllers()
        ]).then(() => {
            this.recalcAll();
            Promise.resolve()
        });
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    stock_keyno: string;
    stockcount_keyno: string;
    stockplace_name: string;
    prod_id: string;
    prod_name: string;
    stockplace_id: string;
    compare_with_stockcount: string;
    sum_quantity_stock: string;
    sum_quantity_stockcount: string;
    sum_quantity_controlled: string;
}

interface ControllerItem {
    stock_keyno: string;
    stocklocation_keyno: string;
    stocklocation_name: string;
    quantity_stock: string;
    quantity_stockcount: string;
    quantity_controlled: string;
}
